import React from 'react';
import './App.css';

const Home = () => (
  <>
    <div className="calculator">
      <h2 className="title">Welcome to Math-Magicians</h2>
      <div className="text">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
        minim veniam, quis nostrud exercitation ullamco laboris nisi ut
        aliquip ex ea commodo consequat. Duis aute irure dolor in
        reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
        culpa qui o!cia deserunt mollit anim id est laborum.
      </div>
    </div>
  </>
);

export default Home;
